import { Container } from "react-bootstrap";

export default function PrivacyInfo() {
  return (
    <Container fluid className="p-4">
      <h1>INFORMAZIONI SULLA PRIVACY</h1>
      <i>Ultimo aggiornamento: 10 Settembre 2026 (versione 2026-09-10)</i>

      <p>
        Questa pagina riassume in italiano, in modo sintetico e leggibile, come
        GetMove tratta i dati personali degli utenti, ai sensi degli artt. 13 e
        14 del Regolamento (UE) 2016/679 (GDPR). Il documento completo è
        disponibile nella <a href="/privacy-policy">Privacy Policy</a>, che
        prevale in caso di difformità.
      </p>

      <ol>
        <li>
          <p>
            <strong>TITOLARE DEL TRATTAMENTO</strong>
          </p>
          <p>
            <span>
              <strong>WebSite strategy di Giambrone Francesco</strong>
            </span>
            <br />
            <span>Corso Roma, 105 — 90042 Borgetto (PA), Italia</span>
            <br />
            <span>
              Email: <strong>support@getmoveapp.com</strong>
            </span>
          </p>
        </li>

        <li>
          <p>
            <strong>QUALI DATI TRATTIAMO</strong>
          </p>
          <ul>
            <li>
              <strong>Dati di registrazione e profilo</strong>: nome, cognome,
              email, numero di telefono, foto profilo, data di nascita, sesso,
              livello di gioco e sport preferiti.
            </li>
            <li>
              <strong>Dati di utilizzo dei servizi</strong>: prenotazioni
              effettuate, partite a cui partecipi, squadre e tornei, risultati,
              statistiche, classifiche e punteggi (ranking), valutazioni di
              affidabilità.
            </li>
            <li>
              <strong>Contenuti generati dall'utente</strong>: messaggi in chat,
              nomi degli ospiti che aggiungi a una partita, note delle
              prenotazioni.
            </li>
            <li>
              <strong>Dati tecnici</strong>: identificativo del dispositivo,
              token per le notifiche push, versione dell'app, log tecnici.
            </li>
            <li>
              <strong>Dati di pagamento e abbonamento</strong>, ove previsti dal
              circolo di riferimento.
            </li>
            <li>
              <strong>Dati relativi ai Quiz e ai Get Move Points</strong>: le
              risposte fornite ai quiz proposti nell'app, il punteggio ottenuto e
              il saldo dei Get Move Points, compresi quelli assegnati dal gestore
              della piattaforma o riscattati presso i circoli.
            </li>
            <li>
              <strong>Preferenze sull'informativa</strong>: la versione
              dell'informativa privacy accettata e la data di accettazione.
            </li>
          </ul>
        </li>

        <li>
          <p>
            <strong>PERCHÉ LI TRATTIAMO E CON QUALE BASE GIURIDICA</strong>
          </p>
          <ul>
            <li>
              <strong>Erogare il servizio</strong> (creare l'account, gestire
              prenotazioni, partite, tornei, classifiche, quiz e Get Move
              Points, inviare notifiche relative alle tue attività e alle
              iniziative della piattaforma) — base giuridica: esecuzione del
              contratto (art. 6.1.b GDPR).
            </li>
            <li>
              <strong>Assistenza e sicurezza</strong> (rispondere alle
              richieste, prevenire abusi, garantire il corretto funzionamento) —
              base giuridica: legittimo interesse (art. 6.1.f GDPR).
            </li>
            <li>
              <strong>Comunicazioni promozionali</strong>, ove previste — base
              giuridica: consenso (art. 6.1.a GDPR), revocabile in qualsiasi
              momento.
            </li>
            <li>
              <strong>Obblighi di legge</strong> (contabili, fiscali) — base
              giuridica: obbligo legale (art. 6.1.c GDPR).
            </li>
          </ul>
        </li>

        <li>
          <p>
            <strong>VISIBILITÀ VERSO GLI ALTRI UTENTI</strong>
          </p>
          <p>
            Alcune informazioni sono visibili ad altri utenti per consentire il
            funzionamento del servizio: il tuo nome e la foto profilo sono
            mostrati ai partecipanti delle partite a cui prendi parte, alle
            strutture presso cui prenoti e, se partecipi a tornei o classifiche,
            nelle relative graduatorie pubbliche all'interno dell'app.
          </p>
        </li>

        <li>
          <p>
            <strong>A CHI COMUNICHIAMO I DATI</strong>
          </p>
          <ul>
            <li>
              Alle <strong>strutture sportive affiliate</strong> presso cui
              effettui una prenotazione, limitatamente a quanto necessario per
              gestirla.
            </li>
            <li>
              A <strong>fornitori tecnologici</strong> che agiscono come
              responsabili del trattamento (hosting e database, servizi di
              autenticazione e notifiche push, strumenti di assistenza).
            </li>
            <li>
              Ad <strong>autorità competenti</strong>, quando previsto dalla
              legge.
            </li>
          </ul>
          <p>
            I dati non sono oggetto di diffusione né di vendita a terzi. Alcuni
            fornitori possono trattare dati al di fuori dello Spazio Economico
            Europeo: in tal caso il trasferimento avviene sulla base di garanzie
            adeguate (es. clausole contrattuali standard).
          </p>
        </li>

        <li>
          <p>
            <strong>PER QUANTO TEMPO LI CONSERVIAMO</strong>
          </p>
          <p>
            I dati dell'account sono conservati finché l'account resta attivo. Se
            elimini l'account, i dati vengono cancellati o resi anonimi, salvo
            quanto debba essere conservato per adempiere a obblighi di legge (ad
            esempio i documenti contabili) o per la difesa di un diritto in sede
            giudiziaria.
          </p>
        </li>

        <li>
          <p>
            <strong>I TUOI DIRITTI</strong>
          </p>
          <p>
            Puoi in ogni momento chiedere l'accesso ai tuoi dati, la rettifica,
            la cancellazione, la limitazione del trattamento, la portabilità, e
            opporti al trattamento fondato sul legittimo interesse. Se il
            trattamento si basa sul consenso, puoi revocarlo in qualsiasi
            momento senza pregiudicare la liceità del trattamento precedente.
          </p>
          <p>
            Per esercitare questi diritti scrivi a{" "}
            <strong>support@getmoveapp.com</strong>. Puoi inoltre eliminare il
            tuo account direttamente dall'app, nella sezione Profilo.
          </p>
          <p>
            Se ritieni che il trattamento violi la normativa, hai diritto di
            proporre reclamo al <strong>Garante per la protezione dei dati
            personali</strong> (www.garanteprivacy.it).
          </p>
        </li>

        <li>
          <p>
            <strong>MINORI</strong>
          </p>
          <p>
            Il servizio è rivolto a utenti che abbiano almeno 13 anni. Se hai
            meno di 18 anni è necessario il consenso di un genitore o di chi
            esercita la responsabilità genitoriale.
          </p>
        </li>

        <li>
          <p>
            <strong>COOKIE E STRUMENTI TECNICI</strong>
          </p>
          <p>
            L'<strong>app</strong> non utilizza cookie. Per funzionare memorizza
            sul dispositivo alcuni dati tecnici strettamente necessari (sessione
            di accesso, preferenze dell'app, token per le notifiche push, stato di
            visualizzazione degli avvisi) e si avvale di servizi di terze parti
            per l'autenticazione, le notifiche e le mappe (Google Firebase,
            Google Maps), che possono raccogliere identificativi tecnici del
            dispositivo secondo le rispettive informative.
          </p>
          <p>
            Il <strong>sito web</strong> getmoveapp.com e il gestionale per i
            circoli utilizzano esclusivamente <strong>cookie tecnici</strong>{" "}
            necessari all'autenticazione e al funzionamento delle pagine, per i
            quali non è richiesto il consenso (art. 122 Codice Privacy). Non
            utilizziamo cookie di profilazione né cookie pubblicitari di terze
            parti. Puoi comunque gestire o eliminare i cookie dalle impostazioni
            del tuo browser: la disattivazione dei cookie tecnici può impedire
            l'accesso alle aree riservate.
          </p>
        </li>

        <li>
          <p>
            <strong>MODIFICHE</strong>
          </p>
          <p>
            Questa informativa può essere aggiornata. Le modifiche rilevanti
            saranno comunicate tramite l'applicazione (con un avviso che
            richiede di prendere visione della nuova versione) o via email.
          </p>
          <p>
            <strong>Aggiornamento del 10 Settembre 2026</strong>: aggiunti i
            dati relativi ai Quiz e ai Get Move Points, precisate le finalità
            delle notifiche sulle iniziative della piattaforma, inserita la
            sezione sui cookie e sugli strumenti tecnici usati da app e sito.
          </p>
        </li>
      </ol>
    </Container>
  );
}
